// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --headerHeight:4rem;
  --headerHeightMobile:calc(var(--headerHeight)*0.8);
}

:root{
  --hamburgerWidth:1.75rem;
  --hamburgerHeight:0.25rem;
}

.menu-toggle{
  display:flex;
  height:3.2rem;
  cursor:pointer;
  -webkit-user-select:none;
          user-select:none;
}

.menu-toggle__hamburger{
    display:inline-block;
  }

.menu-toggle__hamburger > div{
      width:1.75rem;
      height:0.25rem;
      margin:0.25rem 0;
      background-color:#206dd2;
      opacity:1;
    }

.menu-toggle:hover .menu-toggle__hamburger > div, .menu-toggle:active .menu-toggle__hamburger > div{
      background-color:#00429d;
    }

.menu-toggle--is-showing{
    display:flex;
    align-items:center;
    justify-content:flex-end;
  }

.menu-toggle--is-showing .menu-toggle__hamburger{
      transform:scale(0.7);
    }

.menu-toggle--is-showing .menu-toggle__hamburger > div:nth-child(1){
        transform:rotate(-45deg) translate(-4px, 4px);
      }

.menu-toggle--is-showing .menu-toggle__hamburger > div:nth-child(2){
        opacity:0;
      }

.menu-toggle--is-showing .menu-toggle__hamburger > div:nth-child(3){
        transform:rotate(45deg) translate(-7px, -8px);
      }

.menu-toggle__text{
    margin-left:0.25rem;
    text-transform:uppercase;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
